import _ from 'lodash';

export const formatPlanName = (plan) => {
  const planName = plan.replace(/[_]/gi, ' ');

  return _.upperFirst(planName);
};
